export const GCP_INTEGRATION_DEFAULT_SCOPES = [
  "https://www.googleapis.com/auth/compute",
  "https://www.googleapis.com/auth/cloud-platform",
  "https://www.googleapis.com/auth/ndev.clouddns.readwrite",
  "https://www.googleapis.com/auth/devstorage.full_control",
  "https://www.googleapis.com/auth/userinfo.email",
];
